module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0081.jpg?v=741c380f";